import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { videos } from '@/mocks/videos';
import { articles } from '@/mocks/articles';

const hotVideos = videos.slice(0, 8);
const latestArticles = articles.slice(0, 3);

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />

        <VideoGrid
          videos={hotVideos}
          title="热门推荐"
          subtitle="编辑精选，不容错过的热门影视内容"
        />

        <ArticleList
          articles={latestArticles}
          title="影视资讯"
          subtitle="最新影视动态、深度影评和观影指南"
        />

        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}